import './bootstrap'
import React from 'react'
import { render } from 'react-dom'
import App from './app'
import { BrowserRouter as Router } from 'react-router-dom'
import clientData from './utils/client-data'
import { analyticsInit } from './utils/analytics'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'

analyticsInit(clientData)
let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

render(
  <WorldReadyContextProvider locale={clientData.locality.locale}>
    <Router basename={clientData.requestURI}>
      <App />
    </Router>
  </WorldReadyContextProvider>,
  document.getElementById('root'),
)
